// @ts-nocheck

import { HistoryActionTypes } from '../types/actions/history';

export const nextPage = () => ({
  type: HistoryActionTypes.NEXT_OFFSET,
});

export const prevPage = () => ({
  type: HistoryActionTypes.PREV_OFFSET,
});

export const setPage = (page) => ({
  type: HistoryActionTypes.SET_OFFSET,
  payload: {
    page,
  },
});

export const setStartDate = (startDate) => ({
  type: HistoryActionTypes.SET_PERIOD_START,
  payload: {
    startDate,
  },
});

export const setEndDate = (endDate) => ({
  type: HistoryActionTypes.SET_PERIOD_END,
  payload: {
    endDate,
  },
});

export const setFilter = (filter, page) => ({
  type: HistoryActionTypes.SET_FILTER,
  payload: { filter, page },
});

export const setBetslipType = (betslipType) => ({
  type: HistoryActionTypes.SET_BETSLIP_TYPE,
  payload: { betslipType },
});

export const onMountHistory = (routeParams) => ({
  type: HistoryActionTypes.INIT,
  payload: {
    routeParams,
  },
});

export const setIsLoading = (isLoading) => ({
  type: HistoryActionTypes.SET_IS_LOADING,
  payload: {
    isLoading,
  },
});
